export default function (e, selectedSnippet)
{
    let self = this;

    const id = selectedSnippet.data('keditor-snippet-id');
    const localSnippetId = selectedSnippet.data('local-snippet-id');

    const showMessage = (message, isError) =>
    {
        const alertSave = $('.save-content')
        alertSave.fadeIn(500)
        alertSave.removeClass(isError ? 'alert-success' : 'alert-danger alert-warning')
        alertSave.addClass(isError ? 'alert-danger' : 'alert-success')
        alertSave.html(message)
        alertSave.fadeOut(3000)
    }

    const sendDelete = (id, callback) => $.ajax({
        type: "delete",
        url: `${self.options.apiUserComponents}/${id}`,
        headers: {
              Authorization: self.options.accessToken,
        },
        success: function (resp) {
            if(typeof callback === "function")
            {
                callback.call(self, true, resp);
            }
        },
        error: function (jqXHR) {
            if (typeof callback === "function")
            {
                callback.call(self, false, jqXHR);
            }
        },
    });

    const requestDelete = confirm('Tem certeza que deseja deletar este bloco?');
    if (requestDelete)
    {
        sendDelete(id, function (success, resp)
        {
            //Success or local only? delete anyway
            if (success || resp.status === 404)
            {
                selectedSnippet.remove();

                const templateList = JSON.parse(
                    localStorage.getItem('@mf/templates') ?? '[]'
                ).filter((item) => item.id !== localSnippetId);
                
                localStorage.setItem('@mf/templates', JSON.stringify(templateList))

                showMessage('Bloco deletado com sucesso!', false);
            }
            else
            {
                showMessage('Não foi possível deletar o bloco! Entre em contato com o administrador', true);
            }
        });
    }
}